module.exports = __webpack_public_path__ + "img/trunk_7x1_z16.91b31e13.svg";